document.addEventListener('DOMContentLoaded', () => {
  const SELECTORS = {
    trigger: '[data-popup-target]',
    popup: '[data-popup]',
    close: '[data-popup-close]',
    overlay: '.popup-overlay',
    openClass: 'is-open',
    focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  };

  let lastFocusedElement = null;

  // GLOBAL CLICK HANDLER
  document.addEventListener('click', (event) => {

    /* =========================
       OPEN POPUP
    ========================== */
    const trigger = event.target.closest(SELECTORS.trigger);
    if (trigger) {
      event.preventDefault();

      const targetId = trigger.getAttribute('data-popup-target');
      if (!targetId) return;

      // 🔥 FIX: use querySelectorAll + last match
      const popups = document.querySelectorAll(`[data-popup="${targetId}"]`);
      if (!popups.length) return;

      const popup = popups[popups.length - 1]; // SAFE for Shopify DOM order
      openPopup(popup, trigger);
      return;
    }

    /* =========================
       CLOSE POPUP
    ========================== */
    const closeTrigger = event.target.closest(SELECTORS.close);
    const overlayClick =
      event.target.classList.contains(SELECTORS.overlay.replace('.', ''));

    if (closeTrigger || overlayClick) {
      const activePopup = document.querySelector(
        `.${SELECTORS.openClass}[data-popup]`
      );
      if (!activePopup) return;

      // overlay safety
      if (
        overlayClick &&
        !activePopup.contains(event.target) &&
        event.target !== activePopup
      ) {
        return;
      }

      event.preventDefault();
      closePopup(activePopup);
    }
  });

  // ESC + FOCUS TRAP
  document.addEventListener('keydown', (event) => {
    const activePopup = document.querySelector(
      `.${SELECTORS.openClass}[data-popup]`
    );
    if (!activePopup) return;

    if (event.key === 'Escape') {
      closePopup(activePopup);
    }

    if (event.key === 'Tab') {
      trapFocus(event, activePopup);
    }
  });

  /* =========================
     FUNCTIONS
  ========================== */

  function openPopup(popup, trigger) {
    const currentlyOpen = document.querySelector(
      `.${SELECTORS.openClass}[data-popup]`
    );
    if (currentlyOpen && currentlyOpen !== popup) {
      closePopup(currentlyOpen, false);
    }

    lastFocusedElement = trigger;

    popup.classList.add(SELECTORS.openClass);
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    const focusable = popup.querySelectorAll(SELECTORS.focusable);
    if (focusable.length) {
      const closeBtn = popup.querySelector(SELECTORS.close);
      setTimeout(() => (closeBtn || focusable[0]).focus(), 50);
    }
  }

  function closePopup(popup, restoreFocus = true) {
    popup.classList.remove(SELECTORS.openClass);
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (restoreFocus && lastFocusedElement) {
      lastFocusedElement.focus();
      lastFocusedElement = null;
    }
  }

  function trapFocus(event, popup) {
    const focusable = popup.querySelectorAll(SELECTORS.focusable);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      last.focus();
      event.preventDefault();
    } else if (!event.shiftKey && document.activeElement === last) {
      first.focus();
      event.preventDefault();
    }
  }
});
